import { buildDonationsInWindow, toFinancialYear } from './donation-fixtures'
import type { MockPersona } from './types'

const ELLEN_SIGNUP_MS = Date.UTC(2026, 5, 1, 9, 15, 0)
/** Single matched donation a few days after signup. */
const ELLEN_DONATION_MS = Date.UTC(2026, 5, 15, 14, 0, 0)

const ellenDonations = buildDonationsInWindow({
  period: '2026-2027',
  count: 1,
  startMs: ELLEN_DONATION_MS,
  endMs: ELLEN_DONATION_MS,
  idPrefix: 'don-ellen-2026-2027',
})

/** New signup with one donation, no authorisation or issued statement yet. */
export const ellenRipley: MockPersona = {
  id: 'ellen-ripley',
  label: 'Ellen Ripley',
  description: 'Just signed up; one donation on account, no statement yet',
  defaultPlan: 'free',
  me: {
    landingPage: 100,
    emailAddress: 'ellen.ripley@example.com',
    details: {
      firstname: 'Ellen',
      lastname: 'Ripley',
      addressLine1: '12 Nostromo Way',
      addressLine2: 'Flat 4',
      city: 'Bristol',
      postcode: 'BS1 4DJ',
      county: '',
      country: 'United Kingdom',
    },
    accounts: [
      {
        type: 'emailAddress',
        id: 'ellen.ripley@example.com',
        created: new Date(ELLEN_SIGNUP_MS).toISOString(),
        updated: new Date(ELLEN_SIGNUP_MS).toISOString(),
      },
    ],
  },
  donations: {
    financialYears: [toFinancialYear('2026-2027', ellenDonations)],
  },
  statements: { statements: [] },
  authorisation: {
    authorised: new Date(ELLEN_SIGNUP_MS).toISOString(),
    created: new Date(ELLEN_SIGNUP_MS).toISOString(),
    platform: 'Swiftaid',
    expiry: '2027-04-05T23:59:59.999Z',
    canBeExtended: false,
  },
}
